import { palette } from '../../palette';
import { StatusChip } from '../../components/StatusChip';

interface OwnerBadgeProps {
  owner: string;
  color?: string;
}

const OWNER_COLORS: Record<string, string> = {
  Claimant: '#38BDF8',
  Firm: '#FDBA74',
  'V.Law': '#A78BFA',
  Compliance: '#FCA5A5',
  Info: palette.text.secondary,
};

const OwnerBadge = ({ owner, color }: OwnerBadgeProps) => {
  const resolvedColor = color || OWNER_COLORS[owner] || palette.text.secondary;
  return <StatusChip label={owner} color={resolvedColor} />;
};

export default OwnerBadge;
